import styled from "styled-components"
import {Button, Input, notification} from "antd"
import {useState} from "react"
import {YM_COUNTER} from "../inizialize/Metrika"
import http from "../library/network/http"
import sleep from "../library/methods/sleep"
import {isValidPhoneNumber} from 'libphonenumber-js'

const formData = {name: '', contact: '', address: '', trackers: '', comment: ''}

const ContactForm = ({
						 trackers = false,
						 onFinish = function () {
						 },
						 ...props
					 }) => {

	const [data, setData] = useState(formData)
	const [error, setError] = useState(false)
	const [api, contextHolder] = notification.useNotification()

	const update = (key, string) => {
		const pattern = {...data}
		pattern[key] = string
		setData(pattern)
	}

	const check = () => {
		const result = isValidPhoneNumber(data.contact.trim(), 'RU')
		setError(!result)
		return result
	}

	const send = async () => {
		const checked = check()
		if (!checked) return

		const result = await http.post('https://api.ats24.ru/v2/feedback', data)
		if (result.code === 200) {
			onFinish(true)

			if (typeof ym !== 'undefined') {
				ym(YM_COUNTER, 'reachGoal', 'contact_form_submitted')
			}

			await sleep(200)
			api.open({
				message: 'Форма успешно отправлена',
				duration: 5,
				description: 'Менеджер свяжется с вами в самое ближайшее время.',
				pauseOnHover: true
			})
		}

		setData(formData)
	}

	return (
		<Wrapper {...props}>
			{contextHolder}
			<FormWrapper>
				<FormItem>
					<FormTitle>
						Ваше имя
					</FormTitle>
					<FormInput>
						<Input value={data.name} onChange={e => update('name', e.target.value)} variant="borderless"
						/>
					</FormInput>
				</FormItem>
				<FormItem error={error}>
					<FormTitle>
						Телефон*
					</FormTitle>
					<FormInput>
						<Input value={data.contact} onBlur={check} onChange={e => {
							setError(false)
							update('contact', e.target.value)
						}}
							   variant="borderless"/>
					</FormInput>
				</FormItem>
				{trackers ?
					<>
						<FormItem>
							<FormTitle>
								Адрес доставки
							</FormTitle>
							<FormInput>
								<Input value={data.address} onChange={e => update('address', e.target.value)}
									   variant="borderless" size="small"/>
							</FormInput>
						</FormItem>
						<FormItem>
							<FormTitle>
								Количество трекеров
							</FormTitle>
							<FormInput>
								<Input value={data.trackers} onChange={e => update('trackers', e.target.value)}
									   variant="borderless"/>
							</FormInput>
						</FormItem>
					</> : null}
				<FormItem>
					<FormTitle>
						{trackers ? 'Пожелания' : 'Коротко о задачах'}
					</FormTitle>
					<FormInput>
						<Input.TextArea value={data.comment} onChange={e => update('comment', e.target.value)}
										rows={4} variant="borderless"/>
					</FormInput>
				</FormItem>
			</FormWrapper>
			<Button onClick={send} size="large" style={{width: '100%'}}
					color="default" variant="solid">
				{trackers ? 'Заказать' : 'Отправить'}
			</Button>
		</Wrapper>
	)
}

export default ContactForm

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
`
const FormWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.88rem;
    padding-bottom: 0.88rem;
`
const FormItem = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.27rem;
    background-color: ${props => props.error ? '#fad4d1' : '#ebebeb'};
    border-radius: 8px;
    border: solid 2px ${props => props.error ? '#ec544a' : 'transparent'};

    :hover {
        border: solid 2px #000000;
    }
`
const FormTitle = styled.div`
    position: absolute;
    top: 0.55rem;
    left: 0.55rem;
    text-transform: uppercase;
    font-size: 0.77rem;
    z-index: 100;
`
const FormInput = styled.div`
    .ant-input {
        padding: 2rem 0.66rem 0.66rem 0.66rem;
        line-height: 1.4;
    }
`